<mat-password-strength [password]="currentPass" (onStrengthChanged)="changePasswordStrength($event)"></mat-password-strength>

@if (currentPass != null) {
  <p>{{strengthName}}</p>
}